import type { BlockDataFragment } from '../graphql/BlockDataFragment.generated';

import { getBlocksFromBlockConnection } from './getBlocksFromBlockConnection';
import { reassignBlocksInBlockConnection } from './reassignBlocksInBlockConnection';
import { sortBlocksByPosition } from './sortBlocksByPosition';

import type { BlockCursorConnection } from '~/types/graphql';

export function updateBlockPositions(blockConnection: BlockCursorConnection);
export function updateBlockPositions(blocks: BlockDataFragment[]);
/**
 * Goes through the given `blocks` and updates their position property to match their index in the array and sorts them.
 * Useful after deleting a block.
 * @param blocks
 * @returns
 */

export function updateBlockPositions<
    T extends BlockCursorConnection | BlockDataFragment[],
>(blocksOrConnection: T): T {
    if ('edges' in blocksOrConnection) {
        const currentBlocks = getBlocksFromBlockConnection(blocksOrConnection);
        const blocks = sortBlocksByPosition(currentBlocks).map(
            (block, index) => ({
                ...block,
                position: index,
            }),
        );

        return reassignBlocksInBlockConnection(blocks, blocksOrConnection) as T;
    } else if (
        'id' in blocksOrConnection &&
        Array.isArray(blocksOrConnection)
    ) {
        return sortBlocksByPosition(blocksOrConnection).map((block, index) => ({
            ...block,
            position: index,
        })) as T;
    }

    return blocksOrConnection;
}
